import { Outlet } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import WhatsappFab from "@/components/WhatsappFab";

export default function SiteLayout() {
  return (
    <div data-testid="site-layout" className="min-h-screen bg-bone text-ink">
      <Nav />
      <main>
        <Outlet />
      </main>
      <Footer />
      <WhatsappFab />
    </div>
  );
}
